import CardHeader from "../../../../antd/components/CardHeader";
import Loader from "../../../../Components/Shared/Loader";
import useLoading from "../../../../Hooks/useLoading";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { CreateNewsAPI } from "../../../../API/NewsAPI";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../Contexts/AuthContext";
import { useContext } from "react";

interface FormSubmitProps {
    title: string;
    externLink: string;
    file: File;
}

const CreateNews = () => {
    const {userEmail} = useContext(AuthContext);
    const { loading, toggleLoading } = useLoading();
    const navigate = useNavigate();

    const schema = yup.object().shape({
        title: yup.string().max(100, "Limite de caracteres excedido! Limite: 100 Caracteres").required("Por favor, insira um título!"),
        externLink: yup.string().max(500, "Limite de caracteres excedido! Limite: 500 Caracteres").required("Por favor, insira um link para a notícia!"),
        file: yup.mixed<File>().test("required", "Por favor, insira um arquivo!", (file: any) => {
            if (file[0]) return true;
            return false;
        })
    });

    const { register, handleSubmit, formState: { errors } } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const Submit = async (data: FormSubmitProps) => {
        try {
            toggleLoading(true);

            await CreateNewsAPI(data.file, data.title, data.externLink, userEmail).then((resp: IResponseProps) => {
                if(resp.statusCode == 200) {
                    toast.success("Notícia criada com sucesso!");
                    navigate("/managementMenu/news");
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    return (
        <div className='card ml-2 mr-2 mt-4'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Criar Notícia"}
                hasPageBefore={true}
                pageBeforeName={"Gestão de Notícias"}
                linkPageBefore={"/managementMenu/news"}
            />
            <div className='card-body mt-4'>
                <form onSubmit={handleSubmit(data => Submit(data))} autoComplete='false'>
                    <div className='d-flex align-items-start flex-column'>
                        <label className='required'>Título da Notícia: </label>
                        <input className='form-control' {...register("title")} />
                        <p className='error-message'>{errors.title?.message}</p>
                    </div>
                    <div className='d-flex align-items-start flex-column'>
                        <label className='required'>Link da Notícia: </label>
                        <input className='form-control' {...register("externLink")} />
                        <p className='error-message'>{errors.externLink?.message}</p>
                    </div>
                    <div className='d-flex align-items-start flex-column'>
                        <label className='required'>Imagem: </label>
                        <input className='form-control' accept="image/*" type="file" {...register("file")} />
                        <p className='error-message'>{errors.file?.message}</p>
                    </div>
                    <button type='submit' className='btn btn-primary w-100'>Criar Notícia</button>
                </form>
            </div>
        </div>
    )
}

export default CreateNews;